import i18n from '@/i18n/config';

// B5 : les mois étaient une liste française en dur et formatTimestamp figeait
// « fr-CH » — les deux suivent désormais la langue active.
export function formatMonth(date: string): string {
  const [year, month] = date.split('-');
  const d = new Date(Number(year), Number(month) - 1, 1);
  // Entrée malformée (données stockées corrompues) : Intl.format jette un
  // RangeError « Invalid time value » qui faisait tomber toute la page.
  if (!Number.isFinite(d.getTime())) return '—';
  return new Intl.DateTimeFormat(i18n.language, { month: 'long', year: 'numeric' }).format(d);
}

export function formatTimestamp(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString(i18n.language, {
    day: 'numeric', month: 'long', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}
